import { Outlet } from 'react-router-dom'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import accessGroups from 'modules/core/store/collections/accessGroups'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ReviewParticipantsContent } from 'modules/reviews/components/Participants/ReviewParticipantsContent'
import ReviewShowWrapper from 'modules/reviews/components/Show/ReviewShowWrapper'
import { useReviewees } from 'modules/reviews/hooks/useReviewees'
import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'
import groups from 'modules/reviews/store/collections/groups'
import questionGroupConfigs from 'modules/reviews/store/collections/questionGroupConfigs'

import { ReviewParticipantsContext } from './context'

const ParticipantsPage = () => {
  const { review, canEditReview } = useReviewShowContext()
  const form = review
  const formId = form.attributes.id
  const group = form.questionGroupConfigs[0]?.target

  const { loading } = useAsyncData(
    () =>
      Promise.all([
        questionGroupConfigs.fetch({
          data: {
            surveys_form_id: formId,
          },
        }),
        // TODO: why is this needed? there is no dependency on this component
        accessGroups.fetch(),
        groups.fetch(),
      ]),
    [formId]
  )

  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const { loading: loadingReviewees, reviewees, fetchReviewees } = useReviewees(form)

  const accessGroup = group && group?.accessGroup

  if (loading || loadingReviewees || loadingContractVersions) return <Loading />

  if (!group) {
    throw new Error(`Missing target group in Review with id: ${form.attributes.id}`)
  }

  if (!accessGroup) {
    throw new Error(`Missing AccessGroup in Group with id: ${group.attributes.id}`)
  }

  return (
    <>
      <ReviewParticipantsContext.Provider
        value={{
          loadingReviewees,
          reviewees,
          fetchReviewees,
          accessGroup,
        }}
      >
        <ReviewShowWrapper reviewId={formId}>
          <ReviewParticipantsContent
            accessGroup={accessGroup}
            form={form}
            onSubmit={fetchReviewees}
            reviewees={reviewees}
            canEditReview={canEditReview}
            contractVersions={contractVersions}
          />
        </ReviewShowWrapper>
        {!loadingReviewees && <Outlet context={{ review, accessGroup }} />}
      </ReviewParticipantsContext.Provider>
    </>
  )
}

export default observer(ParticipantsPage)
